import * as t from "io-ts";

export const SearchIndex = t.union([
  t.literal("audit"),
  t.literal("company"),
  t.literal("credit"),
  t.literal("enquiry"),
  t.literal("enterprise"),
  t.literal("introduction"),
  t.literal("job"),
  t.literal("onboarding"),
  t.literal("tag"),
  t.literal("transaction"),
]);

export type SearchIndex =
  | "audit"
  | "company"
  | "credit"
  | "enquiry"
  | "enterprise"
  | "introduction"
  | "job"
  | "onboarding"
  | "tag"
  | "transaction";
